module.exports = __webpack_public_path__ + "static/img/Jack base 60cm solid.e6dd253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Jack base 60cm solid.jpg
// module id = 83
// module chunks = 1